import { buildProps } from '@sgui-plus/utils'

export const anchorProps = buildProps({
  offsetTop: Number,
  offsetBottom: Number,
  bounds: {
    type: Number,
    default: 5
  },
  defaultActive: String,
  affix: {
    type: Boolean,
    default: true
  },
  container: String,
  direction: {
    type: String,
    values: ['vertical', 'horizontal'],
    default: 'vertical'
  }
})

export const anchorEmits = {
  onChange: (currentActiveLink: string) => true,
  onClick: (e: Event, info: { title: any, href: string }) => true
}
